<template>
  <div class="entry" v-bind:class="{ sole: sole && control == false }">
    <span class="label" ref="label">
      <div v-if="control == true" style="position: absolute; right: 0px; top: 0px; z-index: 10">
        <b-btn
          variant="outline-warning"
          size="sm"
          class="p-0 m-0"
          v-b-tooltip.hover
          title="Изменить"
          @click="$emit('edit', branch)"
          ><i class="fa fa-lg fa-cog m-1"></i
        ></b-btn>
        <b-btn
          variant="outline-danger"
          size="sm"
          class="p-0 m-0"
          v-b-tooltip.hover
          title="Удалить"
          @click="$emit('remove', [branch.id, index])"
          ><i class="fa fa-lg fa-trash m-1"></i
        ></b-btn>
      </div>
      <div
        class="pr-1"
        style="line-height: 15px !important; position: absolute; top: 50%; transform: translateY(-50%); width: 100%"
      >
        <div v-if="!branch.auto_calc || branch.auto_calc == 'manual'">
          P = <span v-html="toNormal(branch.P)"></span>
        </div>
        <div v-if="branch.G">G = <span v-html="toNormal(branch.G)"></span> кг/с</div>
        <div v-if="branch.factor > 0">
          <b-button variant="primary" style="font-size: 12px" class="m-0 mt-1 p-1" disabled>{{
            devNames[branch.factor]
          }}</b-button>
        </div>
        <div v-else>{{ branch.C }}</div>
        <h6 class="py-1">
          <b-badge v-if="branch.Pt == 1" class="mr-1">P<sub>т</sub></b-badge
          ><b-badge v-if="branch.Pc == 1">P<sub>c</sub></b-badge>
        </h6>
      </div>
      <span
        v-if="branch.auto_calc && branch.auto_calc != 'manual'"
        class="fa-stack fa-lg"
        style="position: absolute; right: -15px; bottom: -15px; z-index: 10"
        v-b-tooltip.hover
        title="Условная вероятность этого события расчитывается автоматически в зависимости от заданных параметров"
      >
        <i class="fa fa-square-o fa-stack-2x"></i>
        <i class="fa fa-magic fa-stack-1x"></i>
      </span>
    </span>

    <div class="branch" v-if="(branch.trees && branch.trees.length > 0) || control == true">
      <branch
        @remove="remove($event)"
        @edit="$emit('edit', $event)"
        @actionAdd="$emit('actionAdd', $event)"
        v-for="(tree, b_index) in branch.trees"
        :index="b_index"
        :key="b_index"
        :devNames="devNames"
        :outflow="outflow"
        :logic="logic"
        :branch.sync="tree"
        :control="control"
        :sole="branch.trees.length == 1 ? true : false"
      ></branch>

      <div v-if="control == true" class="entry" v-bind:class="{ sole: !branch.trees || branch.trees.length < 1 }">
        <span class="label">
          <div
            class="m-1"
            style="
              line-height: 15px !important;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              width: 140px;
            "
          >
            <b-button variant="success" @click="$emit('actionAdd', [branch, outflow])">Добавить</b-button>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import branch from "./branch";
export default {
  name: "branch",
  props: {
    branch: Object,
    sole: Boolean,
    control: Boolean,
    devNames: Object,
    index: Number,
    lastHeight: Number,
    outflow: Number,
    logic: [Object, Array],
  },
  data() {
    return {
      height: 150,
    };
  },
  components: {
    branch,
  },
  methods: {
    remove(params) {
      var id = params[0];
      var index = params[1];
      this.$http
        .post("risk/tree/remove?id=" + id)
        .then(() => {
          this.branch.trees.splice(index, 1);
          this.$emit("clearCalculations");
        })
        .catch((e) => {
          alert("Ошибка", e);
        });
    },
    newBranch() {},
    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "⋅10<sup>-" + val[1] + "</sup>";
      } else {
        if (Number(val) < 1) {
          val = String(val);
          var multiply = 0;
          for (var i in val) {
            if (val[i] == "0" || val[i] == ".") {
              multiply++;
            } else {
              break;
            }
          }
          if (multiply > 3) {
            val = val * Math.pow(10, multiply - 1);
            parseFloat(val).toFixed(2);
            return Math.floor(val * 100) / 100 + "⋅10<sup>-" + (multiply - 1) + "</sup>";
          } else {
            return Number(val).toFixed(2);
          }
        } else {
          return Number(val).toFixed(2);
        }
      }
    },
  },
};
</script>
